<template>
    <div class="general-container">
        <div class="tabs">
            <div class="tabs-left">
                <div
                    :class="['tab-item', v.key === activeTab ? 'tab-item-active' : '']"
                    v-for="v in tabs"
                    :key="v.key"
                    @click="switchTab(v)"
                >
                    <div class="activebar" v-show="v.key === activeTab"></div>
                    {{ v.label }}
                </div>
            </div>
            <div class="tabs-right">
                <el-button class="wl-green" :loading="loading" @click="save">{{ $t('btn_save') }}</el-button>
            </div>
        </div>
        <div class="general-body">
            <GeneralSetting ref="tab_0" v-if="activeTab === 0" @onConfChange="onConfChange"></GeneralSetting>
            <ClientOrganizationStructure ref="tab_1" v-if="activeTab === 1" @onConfChange="onConfChange"></ClientOrganizationStructure>
            <TileConfiguration ref="tab_2" v-if="activeTab === 2" @onConfChange="onConfChange"></TileConfiguration>
        </div>
        <!-- <div class="general-footer">
            <el-button class="wl-green general-footer-btn" :loading="loading" @click="save">{{ $t('btn_save') }}</el-button>
        </div> -->
    </div>
</template>
<script>
import GeneralSetting from './components/GeneralSetting.vue'
import ClientOrganizationStructure from './components/ClientOrganizationStructure.vue'
import TileConfiguration from './components/TileConfiguration.vue'

export default {
    name: 'General',
    components: { GeneralSetting, ClientOrganizationStructure, TileConfiguration },
    beforeRouteLeave(to, from, next) {
        if (this.changed) {
            this.$confirm(this.$t('ask_for_save'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_save'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning'
            }).then(async () => {
                await this.save()
                next();
            }).catch(() => {
                this.changed = false
                window.forbidJump = false
                next();
            })
        }else{
            next();
        }
    },
    data() {return {
        activeTab: 0,
        loading: false,
        changed: false
    }},
    computed: {
        tabs() {
            return [
                {
                    key: 0,
                    label: this.$t('base_info_setting')
                },
                {
                    key: 1,
                    label: this.$t('PAGE_GENERAL_TITLE1')
                },
                {
                    key: 2,
                    label: this.$t('PAGE_GENERAL_TITLE2')
                }
            ]
        }
    },
    mounted() {
        window.addEventListener('beforeunload', this._beforeunloadHandler)
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this._beforeunloadHandler)
    },
    methods: {
        _beforeunloadHandler(event) {
            if (this.changed) {
                event.preventDefault()
            }
        },
        onConfChange(e) {
            this.changed = true
            window.forbidJump = true
        },
        switchTab(v) {
            if (this.changed) {
                this.$confirm(this.$t('ask_for_save'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_save'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(async res => {
                    await this.save()
                }).catch(() => {
                    this.activeTab = v.key
                    this.changed = false
                    window.forbidJump = false
                })
            } else {
                this.activeTab = v.key
            }
        },
        async save() {
            this.loading = true
            await this.$refs[`tab_${this.activeTab}`].handleSave()
            this.changed = false
            window.forbidJump = false
            this.loading = false
            this.$refs.tab_2.getSiteTiles()
        }
    }
}
</script>
<style>
.general-container {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    margin: 20px;
    background-color: white;
    border: solid 1px #e5e6e7;
    border-radius: 5px;
}
.tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    background-color: #f9f9f9;
    border-bottom: solid 1px #e5e6e7;
    border-radius: 5px 5px 0 0;
}

.tabs-left {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.tabs-left .tab-item {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #1b293f;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    padding: 0 20px 0 20px;
    border-right: solid 1px #e5e6e7;
    position: relative;
}

.tabs-left .tab-item-active{
    height: calc(100% + 2px);
    margin-top: 2px;
    background-color: white;
    color: #1e49e2;
    /* border-top: solid 3px #1e49e2; */
}

.tabs-left .tab-item .activebar {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 2px;
    background-color: #1e49e2;
    border-radius: 50%;
}
.tabs-right {
    margin-right: 10px;
}
.general-body {
    width: 100%;
    height: calc(100% - 44px);
    overflow: scroll;
}
.general-footer {
    width: 100%;
    height: 44px;
    border-top: solid 1px #e5e6e7;
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
}
</style>